export const NATIVE_APP_HOSTNAME = 'localhost'
export const NATIVE_IOS_SCHEME = 'capacitor'
export const NATIVE_APP_ORIGIN = `${NATIVE_IOS_SCHEME}://${NATIVE_APP_HOSTNAME}`

export const NATIVE_OAUTH_CALLBACK_SCHEME = 'app.tunetoss'
export const NATIVE_OAUTH_CALLBACK_PATH = '/oauth/discogs'
export const NATIVE_OAUTH_CALLBACK_URL = `${NATIVE_OAUTH_CALLBACK_SCHEME}:${NATIVE_OAUTH_CALLBACK_PATH}`

export const NATIVE_AUTH_VALUE_PATTERN = /^[A-Za-z0-9_-]{43}$/
export const NATIVE_AUTH_CODE_PATTERN = /^ttx_[A-Za-z0-9_-]{43}$/
export const NATIVE_SESSION_TOKEN_PATTERN = /^ttn_[A-Za-z0-9_-]{43}$/
